import styled from 'styled-components';

//engagement main page
const Headerbody = styled.section`
	// common for table UI start

	.userlistwrapper {
		display: inline-grid;
		width: 100%;

		.contentHistoryPlaceHolderText {
			border: var(--px-1) solid var(--neutrals-200);
		}

		.permissionitemview {
			width: 100%;
			height: var(--px-48);
			/* font-size: var(--px-14); */
			display: flex;
			border-collapse: collapse;
			align-items: center;
			justify-content: center;
			border-bottom: var(--px-1) solid var(--neutrals-200);

			&.inactive mgt-person {
				color: var(--neutrals-300);
			}

			&:not(.inactive) .userName {
				color: var(--neutrals-900);
			}

			.grid {
				display: grid;
				grid-template-columns: auto 1fr;
				grid-gap: 0 10px;

				&:last-child {
					text-align: center;
					.description {
						display: inline-flex;
					}
				}
			}

			&:last-child {
				border-bottom: none;
			}
		}

		.userlist-header {
			width: 100%;
			display: inline-block;
			.userlistheader {
				width: 100%;
				height: var(--px-48);
				display: flex;
				border-collapse: collapse;
				background: var(--neutrals-50);
				border: var(--px-1) solid var(--neutrals-200);
				border-radius: var(--px-8) var(--px-8) 0 0;
				border-bottom: none;
			}
		}

		.userlist-body {
			overflow: auto;
			height: calc(100vh - var(--px-360));
			display: inline-block;
			width: 100%;
			border: var(--px-1) solid var(--neutrals-200);
			border-radius: 0 0 var(--px-8) var(--px-8);
			background: var(--neutrals-00white);
			.userlistholder {
				border-bottom: var(--px-1) solid var(--neutrals-200);
			}
		}

		.userlist-header,
		.userlist-body {
			.userlistitem {
				padding: var(--px-10);
				flex: 1 1 auto;
				width: 12%;
				display: block;

				&.header{
					display: flex;
					white-space:nowrap;
					text-overflow: ellipsis;
					overflow: hidden;
					align-items: center;
					height: var(--px-48);
				}

				.description {
					display: flex;
				}

				.ellipses {
					display: flex;
				}

				&.delete {
					width: 4% !important;
					display: flex;
					.editicon-button{
						button.edit-user-edit-btn{
							display: block;
							&[disabled] {
								opacity: 0.2;
								pointer-events: none;
							}
						}
					}
				}

				&.email{
					width: 18%;
				}

				&.userid{
					width: 22%;
				}

				&.status {
					width: 7%;
				}

				&.gui{
					width: 14%;
				}

				&.title{
					width: 12%;

					// .ellipses {
					// 	vertical-align: middle;
					// 	line-height: normal;
					// }
				}

				.detail {
					width: 100%;
					display: inline-grid;

					.delete {
						cursor: pointer;
					}

					.ellipses {
						display: flex;
					}
				}
			}
		}
	}

	// common for table UI end
`;

export default Headerbody;
